import { TableCard } from '../../../../components'
import { HistoricoQueryRequestProvider } from '../core/HistoricoQueryRequestProvider'
import { HistoricoQueryResponseProvider } from '../core/HistoricoQueryResponseProvider'
import { NovidadesTable } from './table/NovidadesTable'

const NovidadesList = () => (
  <TableCard>
    <NovidadesTable />
  </TableCard>
)

export const NovidadesListWrapper = () => (
  <HistoricoQueryRequestProvider>
    <HistoricoQueryResponseProvider>
      <NovidadesList />
    </HistoricoQueryResponseProvider>
  </HistoricoQueryRequestProvider>
)
